// --- React
import React from 'react';
// --- Hooks
import { useDialogsCtxBuilder } from './hooks';
import { useDialogsFormCtxBuilder } from './forms';
// --- Context
import { DialogsCtx } from './context';
// --- UI Components
import { Dialog } from './dialog';

/**
 * DialogsProvider Component
 *
 * This component serves as a provider for the Dialogs context.
 * It wraps its children with the DialogsCtx provider,
 * passing down the dialogs state and actions.
 */
export const DialogsProvider = ({ children }) => {
    const ctx = useDialogsCtxBuilder();
    const form = useDialogsFormCtxBuilder();

    return (
        <DialogsCtx.Provider value={{ ...ctx, form }}>
            {children}
            {ctx.dialogs.map((dialog) => (
                <Dialog key={dialog.uid} {...dialog} />
            ))}
        </DialogsCtx.Provider>
    );
};
